import React, { useContext, useEffect, useState, useCallback } from 'react'
import Form from 'react-bootstrap/Form'
import { Col } from 'react-bootstrap'

import {
  traerDatosContribuyente,
  guardarDatosContribuyente,
  emptyPromise
} from '../utils/requests'
import { useForm, useFieldArray } from 'react-hook-form'
import './DatosContribuyente.css'
import { StepContext } from '../StepContext'
import InputDomicilioContribuyente from '../components/InputDomicilioContribuyente'
import CargandoDatosLoader from '../components/CargandoDatosLoader'
import AlertaDatosContribuyente from '../components/AlertaDatosContribuyente'
import DatosContribuyenteOrgano from './DatosContribuyenteOrgano'

const DatosContribuyente = (props) => {
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  })
  const { register, errors, trigger, formState, getValues, setValue, control } =
    methods
  const { setPuedeAvanzar, setCallback } = useContext(StepContext)
  const [cargandoDatos, setCargandoDatos] = useState(true)
  const [errorApi, setErrorApi] = useState(false)

  const [esPersonaJuridica, setEsPersonaJuridica] = useState(false)
  const patronCorreoElectronico =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'integrante'
  })

  const traerDatos = useCallback(() => {
    traerDatosContribuyente().then(({ status, content }) => {
      setCargandoDatos(false)
      if (status === 200) {
        let contribuyente = content.contribuyente
        let contribuyenteTishDetalle = content.contribuyenteTishDetalle
        let empleados = content.empleados
        const esPersonaJuridica = content.esPersonaJuridica
        setEsPersonaJuridica(esPersonaJuridica)

        if (fields.length === 0) {
          setValue('cuit', contribuyente.conCuit ? contribuyente.conCuit : '')
          setValue(
            'razonSocial',
            contribuyente.conApellidoRazonSocial
              ? contribuyente.conApellidoRazonSocial
              : ''
          )
          setValue(
            'calle',
            contribuyenteTishDetalle.calle ? contribuyenteTishDetalle.calle : ''
          )
          setValue(
            'numeroCalle',
            contribuyenteTishDetalle.numero
              ? contribuyenteTishDetalle.numero
              : ''
          )
          setValue(
            'piso',
            contribuyenteTishDetalle.piso ? contribuyenteTishDetalle.piso : ''
          )
          setValue(
            'codigoPostal',
            contribuyenteTishDetalle.codigo_postal
              ? contribuyenteTishDetalle.codigo_postal
              : ''
          )
          setValue(
            'telefono',
            contribuyenteTishDetalle.telefono
              ? contribuyenteTishDetalle.telefono
              : ''
          )
          setValue(
            'correoElectronico',
            contribuyenteTishDetalle.email ? contribuyenteTishDetalle.email : ''
          )

          if (esPersonaJuridica) {
            if (empleados.length === 0) {
              append()
            } else {
              for (const i in empleados) {
                append()
                setValue(`integrante[${i}].nombre`, empleados[i]['empNombre'])
                setValue(`integrante[${i}].cuil`, empleados[i]['empCUIT'])
                setValue(`integrante[${i}].cargo`, empleados[i]['empCargo'])
                setValue(
                  `integrante[${i}].desde`,
                  empleados[i]['empFechaIngreso']
                )
                setValue(`integrante[${i}].hasta`, empleados[i]['empFechaCese'])
                setValue(`integrante[${i}].calle`, empleados[i]['empCalle'])
                setValue(
                  `integrante[${i}].localidad`,
                  empleados[i]['empLocalidad']
                )
                setValue(
                  `integrante[${i}].numeroCalle`,
                  empleados[i]['empCalleNro']
                )
                setValue(`integrante[${i}].piso`, empleados[i]['empPiso'])
                setValue(
                  `integrante[${i}].codigoPostal`,
                  empleados[i]['empCodPostal']
                )
                setValue(
                  `integrante[${i}].correoElectronico`,
                  empleados[i]['empEmail']
                )
                setValue(
                  `integrante[${i}].cargoVigente`,
                  !empleados[i]['empFechaCese']
                )
                trigger()
              }
            }
          }
          trigger('correoElectronico')
          trigger('telefono')
        }
      } else {
        setErrorApi(content)
      }
    })
  }, [append, setValue, trigger, fields.length])

  useEffect(() => {
    traerDatos()
  }, [traerDatos])

  const guardarPaso = useCallback(() => {
    if (!formState.isValid) {
      trigger()
      return emptyPromise()
    }
    let organo = null
    const organoDirectivo = getValues({ nest: true })['integrante']

    if (organoDirectivo) {
      organo = organoDirectivo.map((i) => {
        return {
          nombre: i.nombre,
          cuit: i.cuil,
          cargo: i.cargo,
          desde: i.desde,
          hasta: i.hasta,
          calle: i.calle,
          numeroCalle: i.numeroCalle,
          piso: i.piso,
          cp: i.codigoPostal,
          email: i.correoElectronico,
          localidad: i.localidad
        }
      })
    }

    const parametros = JSON.stringify({
      telefono: getValues('telefono'),
      email: getValues('correoElectronico'),
      organoDirectivo: organo
    })

    return guardarDatosContribuyente(parametros).then(({ status, content }) => {
      if (status === 200) {
        return true
      }
      return content
    })
  }, [trigger, formState.isValid, getValues])

  useEffect(() => {
    setPuedeAvanzar(true)
    setCallback(guardarPaso)
  }, [formState.isValid, setCallback, guardarPaso, setPuedeAvanzar])

  const renderFormulario = () => {
    return (
      <>
        <h6 className="text-muted text-normal text-uppercase">
          Datos del Contribuyente
        </h6>
        <hr className="margin-bottom-1x" />
        <Form noValidate>
          <Form.Row>
            <Col>
              <Form.Group controlId="formCuit">
                <Form.Label>CUIT*</Form.Label>
                <Form.Control
                  disabled={true}
                  ref={register({ required: false })}
                  type="number"
                  name="cuit"
                  placeholder="Ingrese Cuit"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formApellido">
                <Form.Label>Apellido o Razón Social</Form.Label>
                <Form.Control
                  ref={register({ required: false })}
                  disabled={true}
                  type="text"
                  name="razonSocial"
                  placeholder="Ingrese Apellido o Razón Social"
                />
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputDomicilioContribuyente register={register} />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <Form.Group controlId="formTelefonoContacto">
                <Form.Label>Teléfono de Contacto</Form.Label>
                <Form.Control
                  type="text"
                  name="telefono"
                  ref={register({ pattern: /^[\d]+$/i, required: true })}
                  placeholder="Ingrese Teléfono"
                  isInvalid={!!errors.telefono}
                  isValid={!errors.telefono && getValues('telefono')}
                />
                <Form.Control.Feedback type="invalid">
                  El teléfono solo puede incluir números
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formCorreoContribuyente">
                <Form.Label>Correo electrónico</Form.Label>
                <Form.Control
                  type="email"
                  ref={register({
                    pattern: patronCorreoElectronico,
                    required: true
                  })}
                  isInvalid={!!errors.correoElectronico}
                  isValid={
                    !errors.correoElectronico && getValues('correoElectronico')
                  }
                  name="correoElectronico"
                  placeholder="Ingrese Correo Electrónico"
                />
                <Form.Control.Feedback type="invalid">
                  Debe ingresar un correo electrónico válido
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
          {esPersonaJuridica && (
            <>
              <DatosContribuyenteOrgano
                methods={methods}
                fields={fields}
                remove={remove}
                agregarIntegrante={append}
                patronCorreoElectronico={patronCorreoElectronico}
              />
            </>
          )}
        </Form>
      </>
    )
  }

  return (
    <div className="datos-contribuyente">
      <CargandoDatosLoader cargando={cargandoDatos}>
        {errorApi ? (
          <div style={{ marginBottom: '40px' }}>
            <AlertaDatosContribuyente error={errorApi} />
          </div>
        ) : (
          renderFormulario()
        )}
      </CargandoDatosLoader>
    </div>
  )
}

export default DatosContribuyente
